/* eslint-disable no-console -- sink console desta fase */
import type { IAnalyticsProvider, TAnalyticsProperties } from '../analytics/types';

export class ConsoleAnalyticsProvider implements IAnalyticsProvider {
  track(event: string, properties?: TAnalyticsProperties): void {
    console.info('[analytics:track]', event, properties ?? {});
  }

  async flush(): Promise<void> {}

  async shutdown(): Promise<void> {}
}
